import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {contactData.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {contactData.methods.map((method, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className={`${method.icon} text-xl`}></i>
              </div>
              <h3 className="font-medium text-foreground-800 text-sm mb-1">{method.label}</h3>
              <p className="text-sm text-foreground-500">{method.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}